import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Instagram, Mail } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-[#1C274C] border-t border-[#2a3a6b] py-8" data-id="element-74">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-75">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-76">
          {/* Logo & Copyright */}
          <div className="flex flex-col items-center md:items-start gap-3" data-id="element-77">
            <img src="https://cdn.magicpatterns.com/uploads/x1YDvGzeVU8YQXVtyCccxo/f49a8e45-5d48-4cb5-9cfc-cafe1ddecaa2-removebg-preview.png" alt="AI For Kids Africa" className="h-10 w-auto brightness-0 invert" data-id="element-78" />
            <div className="text-gray-300 text-sm font-medium" data-id="element-79">
              &copy; {new Date().getFullYear()} AI For Kids Africa
            </div>
          </div>

          {/* Links */}
          <div className="flex flex-wrap justify-center gap-6 text-sm font-bold text-gray-300" data-id="element-80">
            <Link to="#" className="hover:text-white transition-colors" data-id="element-81">
              Terms
            </Link>
            <Link to="#" className="hover:text-white transition-colors" data-id="element-82">
              Privacy
            </Link>
            <Link to="#" className="hover:text-white transition-colors" data-id="element-83">
              Accessibility
            </Link>
            <Link to="/contact" className="hover:text-white transition-colors" data-id="element-84">
              Contact
            </Link>
          </div>

          {/* Social Icons */}
          <div className="flex gap-4" data-id="element-85">
            <a href="https://linkedin.com/company/ai-for-kids" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#0A66C2] transition-colors" data-id="element-86">
              <Linkedin className="w-5 h-5" data-id="element-87" />
            </a>
            <a href="https://youtube.com/@aiforkidsglobal" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#FF0000] transition-colors" data-id="element-88">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-89">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" data-id="element-90" />
              </svg>
            </a>
            <a href="https://instagram.com/aiforkidsafrica" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#E4405F] transition-colors" data-id="element-91">
              <Instagram className="w-5 h-5" data-id="element-92" />
            </a>
            <a href="https://x.com/aiforkidsafrica" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-93">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-94">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" data-id="element-95" />
              </svg>
            </a>
            <a href="https://tiktok.com/@ai.for.kids.africa" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-96">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-97">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-98" />
              </svg>
            </a>
            <a href="mailto:info@aiforkidsafrica.com" className="text-gray-400 hover:text-[#FC963E] transition-colors" data-id="element-99">
              <Mail className="w-5 h-5" data-id="element-100" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
};